var _rect, _text, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_2_1",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 2 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 16,
    viewBox: "0 0 80 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1601",
    "data-name": "\\u9577\\u65B9\\u5F62 1601",
    width: 16,
    height: 16,
    rx: 8,
    transform: "translate(64)",
    fill: "#8c96a7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u8A73\\u7D30\\u3092\\u898B\\u308B",
    transform: "translate(30 13)",
    fill: "#8c96a7",
    fontSize: 12,
    fontFamily: "HiraginoSans-W3, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30,
    y: 0
  }, "\u8A73\u7D30\u3092\u898B\u308B"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_503",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 503",
    transform: "translate(68 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1602",
    "data-name": "\\u9577\\u65B9\\u5F62 1602",
    width: 8,
    height: 2,
    transform: "translate(0 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1603",
    "data-name": "\\u9577\\u65B9\\u5F62 1603",
    width: 8,
    height: 2,
    transform: "translate(5) rotate(90)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreButton);
export default __webpack_public_path__ + "static/media/more-button.dd7e316f33076da99916c9449d49c8b1.svg";
export { ForwardRef as ReactComponent };